import { ResourceConfig as CloudResourceConfig } from '../models/configs/resource-config';
import { DecoratorFactory } from '../decoration-base/decorator-factory';

/**
 * Unique key for CloudResource decorator.
 */
export const CLOUD_RESOURCE_KEY = 'cloud-resource'

/**
 * Create resource decorator
 */
export const CloudResource = DecoratorFactory.create<CloudResourceConfig>(CLOUD_RESOURCE_KEY);
